import { gsap } from '../lib/gsap';
import { prefersReducedMotion } from '../lib/lenis';

// Count the stats up when they scroll into view. The markup already holds the
// final value, so no-JS and reduced-motion visitors simply read it.
export function initCounters(): void {
  const counters = Array.from(document.querySelectorAll<HTMLElement>('[data-counter]'));
  if (!counters.length || prefersReducedMotion() || !('IntersectionObserver' in window)) return;

  const format = (value: number, decimals: number): string =>
    value.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });

  const run = (el: HTMLElement): void => {
    const target = parseFloat(el.dataset.counter || '0');
    const decimals = parseInt(el.dataset.decimals || '0', 10);
    if (!Number.isFinite(target)) return;

    const state = { value: 0 };
    el.textContent = format(0, decimals);

    gsap.to(state, {
      value: target,
      duration: 1.5,
      ease: 'power3.out',
      onUpdate: () => {
        el.textContent = format(state.value, decimals);
      },
      onComplete: () => {
        el.textContent = format(target, decimals);
      },
    });
  };

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        run(entry.target as HTMLElement);
        io.unobserve(entry.target);
      });
    },
    { threshold: 0.2 },
  );

  counters.forEach((el) => io.observe(el));
}
